import React, { useEffect, useMemo } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import NotificationsIcon from '@material-ui/icons/Notifications';
// import { mainListItems, secondaryListItems } from './listItems';
import LineChartComponent from './LineChartComponent';
import PieChartComponent from './PieChartComponent';
import Chart from './Chart';
import Deposits from './Deposits';
import Plano from './Plano';
import Orders from './Orders';
import Usuarios from './Usuarios';
import Header from './../../compoments/Header'
import api from './../../services/axios'

function MadeWithLove() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Built with love by the '}
      <Link color="inherit" href="https://material-ui.com/">
        Material-UI
      </Link>
      {' team.'}
    </Typography>
  );
}

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Dashboard({history}) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  
  const [saasClientMe, setSaasClientMe] = React.useState({});
  const [dataSaasClient, setDataSaasClient] = React.useState({});
  const [dataSaasClientFilhos, setDataSaasClientFilhos] = React.useState([]);
  const [tmeData, setTmeData] = React.useState([]);
  const [tmeLines, setTmeLines] = React.useState([]);
  const [tmeDataLoading, setTmeDataLoading] = React.useState(true);

  function addDays (date, daysToAdd) {
    var _24HoursInMilliseconds = 86400000;
    return new Date(date.getTime() + daysToAdd * _24HoursInMilliseconds);
  }

  const [start, setStart] = React.useState(() => {
    const dt = new Date();
    // dt.setDate(dt.getDate())
    // dt.setHours(0)
    // dt.setMinutes(0);
    return addDays(dt, -90);
  });
  const [end, setEnd] =React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(23)
    dt.setMinutes(59);
    return dt;
  });

  const saasClient = useMemo(() => {
    return dataSaasClient ? dataSaasClient : {}
  }, [dataSaasClient])
    
    const dateToString = (date, time, format) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      const yyyy = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      let timeString = '';
      if (time) {

        if(format){
          timeString = ' às ' + hours.toString().padStart(2, '0') + 'h' + minutes.toString().padStart(2, '0');
        }else{
          timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
        }
      }
      
      let dtString = format ?  dd + '/' + mm + '/' + yyyy.toString().substr(-2)  :  yyyy + '-' + mm + '-' + dd;
      
      return  dtString + '' + timeString;
    
    }

    const loadData = async () => {

      const tmeRes = [
        {
          name: '1',
          Fale_conosco: 4000,
          pv: 2400,
          amt: 2400,
        },
        {
          name: '10',
          Fale_conosco: 3000,
          pv: 1398,
          amt: 2210,
        },
        {
          name: '15',
          Fale_conosco: 2000,
          pv: 9800,
          amt: 2290,
        },
        {
          name: '20',
          Fale_conosco: 2780,
          pv: 3908,
          amt: 2000,
        },
        {
          name: '23',
          Fale_conosco: 1590,
          pv: 4500,
          amt: 2181,
        },
        {
          name: '25',
          Fale_conosco: 2390,
          pv: 3800,
          amt: 2500,
        },
        {
          name: '25',
          Fale_conosco: 3490,
          pv: 4300,
          amt: 2100,
        },
      ];
      
      const data = await api.get('/v1/graficos/tme?start=' + dateToString(start, true) + '&end=' + dateToString(end, true));
      //   let saasClientMe = data.data.data;

      // setTmeLines([{

      // }]);
      // console.log('tmeRes', tmeRes)
      // console.log('data.data.dataTme', data.data.dataTme)
      setTmeData(data.data.data);
      // setTmeData(tmeRes);


      setTmeLines(data.data.queues);
      console.log('data.data.queues', data.data.queues)
      // console.log('data.data.data', data.data.data)
      // console.log('tmeRes', tmeRes)
      setTmeDataLoading(false);


    //   const saasClientId = localStorage.getItem('saasClientId')
      
    //   let excludeId=false;
    //   if(saasClientId){
    //     const data = await api.get('/v1/saas/'+saasClientId)
    //     setDataSaasClient(data.data)
    //     excludeId=saasClientId
    //   }else{
    //     setDataSaasClient(saasClientMe)
    //     excludeId=saasClientMe.id
    //   }
    
    //   let dataFilhos = await api.get('/v1/saas/')
    //   dataFilhos = [...dataFilhos.data.data, ...[saasClientMe]]
    //   dataFilhos = dataFilhos.filter((d)=>parseInt(d.id)!==parseInt(excludeId))

    //   setDataSaasClientFilhos(dataFilhos)
    }

    useEffect(() => {
      loadData()
    }, [])

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Header />
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {/*<Container maxWidth="lg" className={classes.container}>*/}
           <Grid container spacing={3}> 
            {/* Chart */}
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={fixedHeightPaper}>
                { !tmeDataLoading &&
                <LineChartComponent title="TME" data={tmeData} lines={tmeLines} />
                }
              </Paper>
            </Grid>   
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={fixedHeightPaper}>
                { !tmeDataLoading &&
                <LineChartComponent title="TMA" data={tmeData} lines={tmeLines} />
                }
              </Paper>
            </Grid>  
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={fixedHeightPaper}>
                { !tmeDataLoading &&
                <LineChartComponent title="Atendimentos e Chamadas" data={tmeData} lines={tmeLines} />
                }
              </Paper>
            </Grid>   
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={fixedHeightPaper}>
                { !tmeDataLoading &&
                <LineChartComponent title="Volume de atendimento" data={tmeData} lines={tmeLines} />
                }
              </Paper>
            </Grid>   
            <Grid item xs={12} md={12} lg={12}>
              <Paper className={fixedHeightPaper}>
                { !tmeDataLoading &&
                <PieChartComponent />
                }
              </Paper>
            </Grid>   
            
            {/* Recent Deposits */}
            {/* <Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper}>
                <Deposits />
              </Paper>
            </Grid> */}
            {/* <Grid item xs={12} md={4} lg={3}>
              <Paper className={fixedHeightPaper}>
                <Plano />
              </Paper>
            </Grid> */}
            {/* Recent Orders */}
            {/* <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Orders />
              </Paper>
            </Grid> */}
            {/* Recent Orders */}
          </Grid> 
         {/*</Container>*/}
        <MadeWithLove />
      </main>
    </div>
  );
}